import { render, staticRenderFns } from "./datei-upload.vue?vue&type=template&id=96019a66&scoped=true"
import script from "./datei-upload.vue?vue&type=script&lang=js"
export * from "./datei-upload.vue?vue&type=script&lang=js"
import style0 from "./datei-upload.vue?vue&type=style&index=0&id=96019a66&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96019a66",
  null
  
)

export default component.exports